import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser";
import { InputField, Button } from "@cakrawalajakarta/shared-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";

export const Kontak = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Mengirim pesan...");

    try {
      const result = await emailjs.send(
        "service_z82jhct",
        "template_9wvasfo",
        formData,
        "vnmhykBI-1OZax2wq"
      );

      if (result.text === "OK") {
        setStatus("Pesan berhasil dikirim!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus("Terjadi kesalahan, coba lagi nanti.");
      }
    } catch (error) {
      setStatus("Terjadi kesalahan, coba lagi nanti.");
      console.error("Error sending email:", error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="w-full min-h-screen py-20 text-center text-lime-600 flex-col justify-center relative bg-white">
      <div className="container mx-auto px-4">
        {/*  <motion.h2
          className="text-xs sm:text-base md:text-lg font-normal uppercase mb-1 md:mb-2 text-lime-600"
          initial={{ opacity: 0, y: -15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          viewport={{ once: true }}
        >
          PT CAKRAWALA JAKARTA KREATIF
        </motion.h2>

        <motion.p
          className="text-xl sm:text-2xl md:text-4xl lg:text-5xl font-black mx-auto mb-8 md:mb-16 text-lime-600 px-4"
          initial={{ opacity: 0, y: -15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3, ease: "easeInOut" }}
          viewport={{ once: true }}
        >
          HUBUNGI KAMI
        </motion.p> */}

        <div className="max-w-6xl mx-auto space-y-4">
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="bg-white rounded-xl px-4 py-6 border border-slate-200">
              <div className="space-y-4">
                {/* Email */}
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                  viewport={{ once: true }}
                >
                  <div className="flex items-start">
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      className="w-4 h-4 text-lime-600 mt-1 mr-2"
                    />
                    <div>
                      <p className="text-md text-lime-600 font-bold">Email</p>
                      <a
                        href="mailto:cakrawalajakartakreatif@gmail.com"
                        className="text-lg text-lime-800 hover:underline"
                      >
                        cakrawalajakartakreatif@gmail.com
                      </a>
                    </div>
                  </div>
                </motion.div>

                {/* WhatsApp */}
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.5 }}
                  viewport={{ once: true }}
                >
                  <div className="flex items-start">
                    <FontAwesomeIcon
                      icon={faPhone}
                      className="w-4 h-4 text-lime-600 mt-1 mr-2"
                    />
                    <div>
                      <p className="text-md text-lime-600 font-bold">Telepon</p>
                      <a
                        href="https://wa.me/6281212303426"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-lg text-lime-800 hover:underline"
                      >
                        +62-812-1230-3426
                      </a>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="bg-white rounded-xl px-4 py-6 border border-slate-200">
              <h3 className="text-xl font-bold text-lime-600 mb-4">
                Kirim Pesan
              </h3>
              <form onSubmit={handleSubmit} className="space-y-4">
                <InputField
                  label="Nama Lengkap"
                  name="name"
                  type="text"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  labelColor="text-lime-800"
                />

                <InputField
                  label="Email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  labelColor="text-lime-800"
                />

                <InputField
                  label="Pesan"
                  name="message"
                  type="textarea"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  labelColor="text-lime-800"
                  style={{ resize: "vertical", minHeight: "200px" }}
                  rows={8}
                  placeholder="Tulis pesan Anda di sini..."
                />

                <Button
                  type="submit"
                  variant="primary"
                  className="w-full mt-4"
                >
                  Kirim Pesan
                </Button>
              </form>

              {status && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className={`mt-4 p-4 rounded-xl ${
                    status === "Pesan berhasil dikirim!"
                      ? "bg-green-50 text-green-800"
                      : status === "Mengirim pesan..."
                      ? "bg-lime-50 text-lime-800"
                      : "bg-red-50 text-red-800"
                  }`}
                >
                  <p className="text-md font-medium">{status}</p>
                </motion.div>
              )}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
